import { ApiCore } from './utilities/core'


export const customerEffortAssessmentAPI = (tenantSlug: string) => {
    return new ApiCore({
        getSingle: true,
        put: true,
        url: `api/${tenantSlug}/cea`
    })
};